import React from 'react';
import PropTypes from 'prop-types';
import {PlainText} from '../PlainText';
import './style.scss';

export class SubHeading extends React.Component {
  render() {
    return <PlainText {...this.props} className='subHeading' />;
  }
}
SubHeading.propTypes = {
  type: PropTypes.string,
  content: PropTypes.array,
  text: PropTypes.string.isRequired,
};
